import { render, staticRenderFns } from "./yc-annals-target.vue?vue&type=template&id=60cc03de&scoped=true&"
import script from "./yc-annals-target.vue?vue&type=script&lang=js&"
export * from "./yc-annals-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc03de",
  null
  
)

export default component.exports